@import "styles/variables";

.dropdown-select-container {
  margin: 20px 0 0;
}

.wrapper {
  position: relative;
}

.select {
  margin: var(--spacing-third) 0 0;
  position: relative;
  display: flex;
  width: 100%;
  padding: var(--spacing-third) var(--spacing-half);
  line-height: 20px;

  appearance: none;

  background-color: var(--color-white);
  border: 1px solid var(--color-grey);
  border-radius: var(--input-border-radius);

  font-family: var(--font-stack-default);
  font-size: var(--font-size-medium);
  color: var(--color-black);
  cursor: pointer;

  outline: none;
  overflow: visible;
  transition: box-shadow 0.1s ease-out, transform 0.1s ease-out;
}

.select:focus {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);  
  transform: translateY(-1px);
}

.active {
  background: var(--color-white) !important;
}

.select__arrow {
	position: absolute;
	top: 16px;
	right: 15px;
	width: 0;
	height: 0;
	pointer-events: none;
	border-width: 8px 5px 0 5px;
	border-style: solid;
	border-color: var(--color-grey) transparent transparent transparent;
}
.select:hover ~ .select__arrow,
.select:focus ~ .select__arrow {
	border-top-color: var(--color-black);
}

select::-ms-expand {
  display: none;
}